import Icon from '@xo-union/tk-component-icons';
import RightRail, { Content, Header } from '../../libs/gs-component-right-rail';
import { Overline } from '@xo-union/tk-ui-typography';
import pluralize from 'pluralize';
import React from 'react';

import { Batch, SUCCESS_STATUSES } from './SentMessageItem';
import styles from './sentMessageRail.scss';

interface Props {
  open: boolean;
  batch?: Batch;
  onClose: () => void;
}

interface SplitGuest {
  failed: Batch['guests'];
  delivered: Batch['guests'];
}

interface P {
  type?: string;
  guests?: Batch['guests'];
  status: 'delivered' | 'failed';
  displayName?: string;
}

const Row: React.FC<P> = ({ type, guests, status, displayName }) => {
  if (guests?.length) {
    return (
      <>
        <Overline className={styles.header}>
          {`${guests.length} ${pluralize('Messages', guests.length)} ${status}`}
        </Overline>
        {guests.map(guest => (
          <div key={guest.id} className={styles.row}>
            {guest.person ? (
              <>
                <div>
                  {guest.person.firstName || ''} {guest.person.lastName || ''}
                </div>
                <div className={styles.subText}>
                  {displayName !== 'Remind Guests to RSVP'
                    ? type === 'email'
                      ? guest.person.email
                      : guest.person.phone
                    : null}
                </div>
                {guest.reply && guest.reply === 'submitted' ? (
                  <div className={styles.reply}>
                    <Icon name="checkmark_circle" size="sm" />
                    <div>Submitted</div>
                  </div>
                ) : (
                  guest.reply && (
                    <>
                      <br />
                      <div className={styles.reply}>Reply: "{guest.reply}"</div>
                    </>
                  )
                )}
              </>
            ) : (
              'Guest Unknown'
            )}
          </div>
        ))}
      </>
    );
  }

  return null;
};

const SentMessageRail: React.FC<Props> = ({ open, onClose, batch }) => {
  const splitGuest = batch?.guests.reduce<SplitGuest>(
    (initial, val) => {
      if (SUCCESS_STATUSES.includes(val.status)) {
        return {
          ...initial,
          delivered: [...initial.delivered, val],
        };
      }

      return {
        ...initial,
        failed: [...initial.failed, val],
      };
    },
    { failed: [], delivered: [] }
  );

  return (
    <RightRail open={open} onEscapeKey={onClose}>
      <Header onClose={onClose}>Message Statuses</Header>
      <Content className={styles.container}>
        <Row guests={splitGuest?.failed} type={batch?.type} status="failed" displayName={batch?.sequenceDisplayName} />
        <Row
          guests={splitGuest?.delivered}
          type={batch?.type}
          status="delivered"
          displayName={batch?.sequenceDisplayName}
        />
      </Content>
    </RightRail>
  );
};

export default SentMessageRail;
